import { useEffect } from 'react';

import { selectRedirectUrl } from '@/features/redirectUrl/selectors';
import { setRedirectUrl } from '@/features/redirectUrl/slice';

import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

const useRedirectUrl = () => {
  const dispatch = useDispatch();

  const redirect = useSelector(selectRedirectUrl);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const url = searchParams.get('redirect_url');
    if (url) {
      dispatch(setRedirectUrl(url));
    }
  }, [dispatch, searchParams]);

  return redirect;
};

export default useRedirectUrl;
